import { inject, Pipe, type PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'positionTranslate',
    standalone: true,
})
export class PositionTranslatePipe implements PipeTransform {
    private readonly _translate = inject(TranslateService);

    transform(position: number): string {
        const positionKey = this._getPositionKey(position);
        return this._translate.instant(`position.${positionKey}`, { position });
    }

    private _getPositionKey(position: number): string {
        if (position === 1) {
            return 'first';
        }
        if (position === 2) {
            return 'second';
        }
        if (position === 3) {
            return 'third';
        }
        if (position <= 10) {
            return 'top_ten';
        }
        if (position <= 15) {
            return 'top_fifteen';
        }
        if (position <= 20) {
            return 'top_twenty';
        }
        return 'other';
    }
}
